import { createWithEqualityFn as create } from "zustand/traditional";

export function createState<T>(defaultValue: T) {
  return create<{
    value: T;
    setValue: (value: T) => void;
  }>((set) => ({
    value: defaultValue,
    setValue: (value) => set({ value }),
  }));
}
